(function (){
    'use strict';

    angular
        .module('services')
        .service('InvoicePaymentFeeService', InvoicePaymentFeeService);

    InvoicePaymentFeeService.$inject = ['$http', 'API_BASE'];

    function InvoicePaymentFeeService($http, API_BASE) {

        var service = this;

        service.getFees   = getFees;
        

        function getFees(query) {
            return $http.get(API_BASE + '/invoice/payment_get_fees', {params: query});
        }
       
    }
})();